/**
 * @flow
 * @format
 */

import React from 'react';
import { compose, type HOC } from 'recompose';
import { connect, type Connector } from 'react-redux';

import StepWrapper from './components/StepWrapper';
import ExportReportWrapper from './components/ExportReportWrapper';
import AnalysisWrapper from './components/AnalysisWrapper';
import BomWrapper from './components/BomWrapper';
import SchematicWrapper from './components/SchematicWrapper';
import withLoader from './hoc/withLoader';
import withErrorHandler from './hoc/withErrorHandler';
import { Steps } from './utils/constants';
import { getStepDataByKey } from './utils/stepHelpers';
import { getCurrentStep, isLoading } from './selectors/design';
import { hasError } from './selectors/errors';

import classes from './App.scss';

// const debug = require('debug')('app:');
type ReduxPropsType = {
  loading: boolean,
  hasError: boolean,
  currentStep: string,
};

type OwnProps = {};
type PropsType = ReduxPropsType;

class App extends React.PureComponent<PropsType, *> {
  props: PropsType;

  render() {
    const { currentStep } = this.props;
    const stepData: StepData = getStepDataByKey(currentStep);

    switch (currentStep) {
      case Steps.STEP_ANALYSIS: {
        return (
          <div className={classes.wrapper}>
            <AnalysisWrapper />
          </div>
        );
      }

      case Steps.REPORT: {
        return (
          <div className={classes.wrapper}>
            <ExportReportWrapper />
          </div>
        );
      }

      case Steps.BOM: {
        return (
          <div className={classes.wrapper}>
            <BomWrapper />
          </div>
        );
      }

      case Steps.SCHEMATIC: {
        return (
          <div className={classes.wrapper}>
            <SchematicWrapper />
          </div>
        );
      }

      default: {
        return (
          <div className={classes.wrapper}>
            <StepWrapper data={stepData} />
          </div>
        );
      }
    }
  }
}

function mapStateToProps(state: AppStateType): ReduxPropsType {
  return {
    loading: isLoading(state),
    hasError: hasError(state),
    currentStep: getCurrentStep(state),
  };
}

const connector: Connector<OwnProps, PropsType> = connect(mapStateToProps);

const enhancer: HOC<*, OwnProps> = compose(
  connector,
  withErrorHandler,
  withLoader,
);

export default enhancer(App);



// WEBPACK FOOTER //
// ./src/App.js